const openpgp = require('openpgp/dist/compat/openpgp.min')

/**
 * 
 * @param {*} targetString - the string to be encrypted
 * @param {*} pgpPublicKey - the base64 encoded pgp public key
 */
export async function pgpEncrypt(targetString, pgpPublicKey) {
  const pubKey = atob(pgpPublicKey);

  const message = openpgp.message.fromText(targetString);

  const key = await openpgp.key.readArmored(pubKey.trim());

  const { data: encrypted } = await openpgp.encrypt({
    message, // input as Message object
    publicKeys: key.keys[0], // for encryption
  });

  return btoa(encrypted);
}

